import { Link } from "react-router-dom";
import config from "../config";

export default function LeftNavLink(props) {
  const { insideRouter, item, children } = props;
  let markup;

  if (item.subitems && item.subitems.length) {
    markup = <a> {children}</a>;
  } else if (item.isServerSideLink) {
    markup = <a href={item.to}>{children}</a>;
  } else if (insideRouter) {
    markup = <Link to={item.to}>{children}</Link>;
  } else {
    markup = <a href={`${config.basename}${item.to}`}>{children}</a>;
  }
  return markup;
}
